<template>

    <div class="modal fade" id="newMessageNotificationModal" tabindex="-1" aria-labelledby="newMessageNotificationModal" aria-hidden="true" style="z-index:99999;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Nieuwe berichten</p>
                    </div>
                    <button type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body pt-3 pb-4 px-4">
                    <p>Er is een nieuw bericht binnengekomen.</p>
                    <p v-if="conversationItem.title" class="fw-bold">Gesprek #{{ conversationItem.dossierNr }} - {{ conversationItem.title }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary ms-auto px-3 py-2 text-sm" @click="onOkClick" data-bs-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { EventBus } from "../../../event-bus";

export default {
    name: 'new-message-notification-modal',
    data() {
        return {
            modal: null,
            conversationItem: ''
        }
    },
    methods: {
        emitDismissed() {
            if (this.conversationItem && this.conversationItem.conversationId && this.conversationItem.messageId) {
                EventBus.$emit('newMessageDismissed', {
                    conversationId: this.conversationItem.conversationId,
                    messageId: this.conversationItem.messageId,
                });
            }
        },
        onOkClick() {
            this.emitDismissed();
        }
    },
    mounted() {
        const el = document.getElementById('newMessageNotificationModal');
        this.modal = new bootstrap.Modal(el);

        // Re-show with latest payload
        EventBus.$on('newMessageReceived', (conversationItem) => {
            this.conversationItem = conversationItem || '';
            this.modal.show();
        });

        // When modal is closed (OK button or X), mark as dismissed one-time
        el.addEventListener('hidden.bs.modal', () => {
            this.emitDismissed();
        });
    }
}
</script>
